import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetProvincesListCommand extends IRequestCommand<
  IGetProvincesResponse,
  ErrorDetails,
  IGetProvincesCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _replaceDefaultHeader = true;
  override _canAddCustomHeaders = false;
  override _needAuthenticate = false;

  public override setParameters(parameters: IGetProvincesCommandParameters) {
    this.urlSections.push('multiregion');
    this.urlSections.push('states');
    this.urlSections.push('countryId');
    this.urlSections.push(parameters.countryId);
    //this.paramsSections.push(`name=${parameters.terms}`);
    this.composeUrl();
  }
}

export interface IGetProvincesCommandParameters extends ICommandParameters {
  terms: string;
  countryId: string
}

export interface IGetProvincesResponse extends ICommandResponse {}
